/**
 * Created by hp on 2017/6/29.
 */
import React, {Component} from "react";
import {Mask} from "react-weui";

import "../styles/WKDialog.css";

export default class WKDialog extends Component {
    render() {
        const {show, title, children, redirectUrl, onClick, closeText, onRequestClose, confirmStyle} = this.props;
        return (
            <div className="wk-dialog" style={{display: show ? 'block' : 'none'}}>
                <Mask onClick={onRequestClose}/>
                <div className="dialog-template">
                    <div className="dialog-content">
                        <p className="text-center"> {title} </p>
                        {children}
                    </div>
                    {closeText &&
                    <div className="dialog-btn">
                        <a className="dialog-close" href={redirectUrl} onClick={onClick} style={{fontSize: "16px"}}>
                            {closeText}
                        </a>
                    </div>
                    }
                    {confirmStyle &&
                    <div className="confirm-btn weui-flex">
                        <a className="confirm-no weui-flex__item"
                           onClick={confirmStyle.clickNoHandle}>{confirmStyle.noText}</a>
                        <a className="confirm-yes weui-flex__item"
                           onClick={confirmStyle.clickYesHandle}>{confirmStyle.yesText}</a>
                    </div>
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/WKDialog.js